import { Button, Intent } from "@blueprintjs/core";
import { IconNames } from "@blueprintjs/icons";
import * as React from "react";

import { useAuth } from "../../contexts";
import { useTl } from "../../hooks";
import { ETLCodes } from "../../locales/ETLCodes";
import { ICustomButtonProps } from "./ICustomButtonProps";

interface IViewButtonProps extends ICustomButtonProps {
  specificRights?: { module: string; tab?: string };
}

export const ViewButton: React.FunctionComponent<IViewButtonProps> = ({
  minimal = true,
  onClick,
  loading,
  text,
  disabled,
  intent = Intent.NONE,
  tabIndex,
  specificRights
}) => {
  const { t } = useTl();
  const { getCurrentPermission, hasPermission } = useAuth();
  const hasRights = React.useMemo(
    () =>
      !!specificRights
        ? hasPermission(specificRights.module, "R", specificRights.tab)
        : getCurrentPermission()?.permission?.includes("R"),
    [getCurrentPermission, hasPermission, specificRights]
  );

  return hasRights ? (
    <Button
      icon={IconNames.EYE_OPEN}
      minimal={minimal}
      onClick={onClick}
      text={text ? text : minimal ? null : t(ETLCodes.General_View)}
      intent={intent}
      loading={loading}
      disabled={disabled}
      tabIndex={tabIndex}
    />
  ) : (
    <></>
  );
};
